// action - account reducer firebase
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const REGISTER = "REGISTER";
export const FIREBASE_STATE_CHANGED = "FIREBASE_STATE_CHANGED";

// action admin - Login in MERN
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const ADMIN_LOADED = "ADMIN_LOADED";
export const AUTH_FAIL = "AUTH_FAIL";
export const SET_ALERT = "SET_ALERT";
export const DELETE_ALERT = "DELETE_ALERT";
export const DELETE_ALL_ALERT = "DELETE_ALL_ALERT";
export const LOGIN_SUB_ADMIN_SUCCESS = "LOGIN_SUB_ADMIN_SUCCESS";

//user get details
export const GET_ALL_PLAYER = "GET_ALL_PLAYER";
export const GET_USER_TRIP_DETAIL = "GET_USER_TRIP_DETAIL";

// Invitation
export const GET_ALL_INVITATION_LIST = "GET_ALL_INVITATION_LIST";

// admin
export const GET_ALL_ADMIN = "GET_ALL_ADMIN";
export const GET_ADMIN_REPORT_DATA = "GET_ADMIN_REPORT_DATA";
export const GET_REPORT_DATA = "GET_REPORT_DATA";

//setting get
export const GET_SETTING = "GET_SETTING";